import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import UnfoldLessIcon from '@material-ui/icons/UnfoldLess';

const useStyles = makeStyles({
  root: {
    backgroundColor: '#ffffff',
    borderRadius: 1,
    marginBottom: 5,
  },
  content: {
    color: '#3f51b5',
    fontSize: '20px',
    padding: '10px',
  },
});

function GeneralAddCard({
  title,
  children,
}) {
  const classes = useStyles();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const renderCollapsedIcon = () => {
    if (isCollapsed) return <UnfoldLessIcon />;
    return <UnfoldMoreIcon />;
  };

  const onChange = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Accordion
      onChange={onChange}
      m={2}
      classes={{
        root: classes.root,
      }}
    >
      <AccordionSummary
        expandIcon={renderCollapsedIcon()}
        aria-controls="panel1c-content"
        classes={{
          content: classes.content,
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

GeneralAddCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};

GeneralAddCard.defaultProps = {
  title: '',
  children: null,
};

export default GeneralAddCard;
